<template>
    <div class="captcha-settings">
        <div class="settings-group">
            <label class="settings-label">
                Alan Etiketi
                <span class="settings-label-required">*</span>
            </label>
            <input
                type="text"
                v-model="localFieldLabel"
                @input="updateField"
                class="settings-input"
                placeholder="Güvenlik Doğrulaması"
                ref="fieldLabelInput"
            />
        </div>

        <div class="settings-group">
            <label class="settings-label">Hizalama</label>
            <select
                v-model="localAlign"
                @change="updateField"
                class="settings-select"
            >
                <option value="left">Sol</option>
                <option value="center">Merkez</option>
                <option value="right">Sağ</option>
            </select>
        </div>

        <div class="settings-group">
            <label class="settings-label">Placeholder Metni</label>
            <input
                type="text"
                v-model="localPlaceholder"
                @input="updateField"
                class="settings-input"
                placeholder="Yukarıdaki kodu girin"
                ref="placeholderInput"
            />
        </div>

        <div class="settings-group">
            <label class="settings-label">Görünürlük</label>
            <div class="settings-checkbox-group">
                <input
                    type="checkbox"
                    id="captcha-visibility"
                    v-model="localVisibility"
                    @change="updateField"
                    class="settings-checkbox"
                />
                <label for="captcha-visibility" class="settings-checkbox-label">
                    Alan görünür
                </label>
            </div>
        </div>

        <div class="settings-group">
            <label for="slug-input" class="settings-label">URL Parametresi</label>
            <input
                type="text"
                id="slug-input"
                v-model="localSlug"
                @input="setSlug($event.target.value)"
                class="settings-input"
                placeholder="captcha"
                ref="slugInput"
            />
            <small class="settings-help">URL parametrelerinde kullanılacak benzersiz tanımlayıcı</small>
        </div>

    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "CaptchaSettings",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            localFieldLabel: "",
            localAlign: "center",
            localPlaceholder: "",
            localVisibility: true,
            localSlug: "",
            updateTimer: null,
            isInitialLoad: true,
        };
    },
    created() {
        this.initializeData();
    },
    methods: {
        ...mapActions({
            updateFormField: "forms/updateFormField",
        }),

        initializeData() {
            if (this.item) {
                console.log('🔴 CaptchaSettings initializeData item:', this.item);
                this.localFieldLabel = this.item.fieldLabel || "Güvenlik Doğrulaması";
                this.localAlign = this.item.align || "center";
                this.localPlaceholder = this.item.placeholder || "Yukarıdaki kodu girin";
                this.localVisibility = this.item.visibility !== undefined ? this.item.visibility : true;
                this.localSlug = this.item.slug || "";
                console.log('🔴 CaptchaSettings initialized values:', {
                    localFieldLabel: this.localFieldLabel,
                    localAlign: this.localAlign,
                    localPlaceholder: this.localPlaceholder
                });
            }
        },

        setSlug(slug) {
            this.localSlug = this.sanitizeSlug(slug);
            this.updateField();
        },

        sanitizeSlug(slug) {
            if (!slug) return '';

            return slug
                .replace(/ğ/gim, "g")
                .replace(/ü/gim, "u")
                .replace(/ş/gim, "s")
                .replace(/ı/gim, "i")
                .replace(/ö/gim, "o")
                .replace(/ç/gim, "c")
                .replace(/[^a-z0-9-]/gim, "-")
                .replace(/-+/gim, "-")
                .replace(/^-|-$/gim, "")
                .toLowerCase();
        },

        updateField() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
                self.$emit('update-captcha-field-label', self.localFieldLabel);
                self.$emit('update-captcha-align', self.localAlign);
                self.$emit('update-captcha-placeholder', self.localPlaceholder);
                self.$emit('update-captcha-is-required', true);

                const updateFields = {
                    visibility: self.localVisibility,
                    slug: self.localSlug,
                    captcha: {
                        fieldLabel: self.localFieldLabel,
                        align: self.localAlign,
                        placeholder: self.localPlaceholder,
                        isRequired: true,
                    }
                };

                console.log('🔴 Captcha settings updating:', {
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateFields,
                    item: self.item
                });

                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateFields,
                });
                console.log('🔴 Captcha settings updateFormField called');
            }, 800);
        },
    },
    watch: {
        item: {
            deep: true,
            immediate: true,
            handler: function (val, oldVal) {
                if (!val) return;

                console.log('🔴 CaptchaSettings item watcher:', {
                    val,
                    oldVal,
                    fieldLabel: val.fieldLabel,
                    align: val.align,
                    placeholder: val.placeholder
                });

                const isInitialLoad = !oldVal || oldVal !== val;

                if (isInitialLoad) {
                    const fieldLabelInput = this.$refs.fieldLabelInput;
                    const placeholderInput = this.$refs.placeholderInput;

                    if (!fieldLabelInput || document.activeElement !== fieldLabelInput) {
                        this.localFieldLabel = val.fieldLabel || "Güvenlik Doğrulaması";
                    }

                    this.localAlign = val.align || "center";

                    if (!placeholderInput || document.activeElement !== placeholderInput) {
                        this.localPlaceholder = val.placeholder || "Yukarıdaki kodu girin";
                    }

                    this.localVisibility = val.visibility !== undefined ? val.visibility : true;
                    
                    const slugInput = this.$refs.slugInput;
                    if (!slugInput || document.activeElement !== slugInput) {
                        this.localSlug = val.slug || "";
                    }

                    console.log('🔴 CaptchaSettings watcher updated values:', {
                        localFieldLabel: this.localFieldLabel,
                        localAlign: this.localAlign,
                        localPlaceholder: this.localPlaceholder
                    });
                }
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.captcha-settings {
    padding: clamp(1rem, 2.5vw, 1.5rem);
    background: linear-gradient(145deg,
        rgba(255, 255, 255, 0.95) 0%,
        rgba(255, 255, 255, 0.85) 100%);
    border-radius: 0.75rem;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.settings-group {
    margin-bottom: clamp(1rem, 2.5vw, 1.5rem);

    &:last-child {
        margin-bottom: 0;
    }
}

.settings-label {
    display: block;
    font-size: clamp(0.875rem, 1.8vw, 1rem);
    font-weight: 600;
    color: rgba(55, 65, 81, 0.9);
    margin-bottom: clamp(0.375rem, 1vw, 0.5rem);

    .settings-label-required {
        color: #ef4444;
        margin-left: 0.25rem;
    }
}

.settings-input {
    width: 100%;
    padding: clamp(0.75rem, 1.8vw, 1rem);
    font-size: clamp(0.875rem, 1.8vw, 1rem);
    color: rgba(55, 65, 81, 0.9);
    background: rgba(255, 255, 255, 0.8);
    border: 2px solid rgba(229, 231, 235, 0.8);
    border-radius: 0.5rem;
    transition: all 0.2s ease;

    &:focus {
        outline: none;
        border-color: #f26a52;
        background: rgba(255, 255, 255, 0.95);
        box-shadow: 0 0 0 3px rgba(242, 106, 82, 0.1);
    }

    &:hover {
        border-color: rgba(242, 106, 82, 0.5);
    }
}

.settings-select {
    @extend .settings-input;
    cursor: pointer;

    option {
        padding: 0.5rem;
    }
}

.settings-help {
    font-size: clamp(0.75rem, 1.5vw, 0.875rem);
    color: rgba(107, 114, 128, 0.7);
    margin-top: clamp(0.25rem, 0.8vw, 0.375rem);
    line-height: 1.4;
}

.settings-checkbox-group {
    display: flex;
    align-items: center;
    gap: clamp(0.5rem, 1.2vw, 0.75rem);
}

.settings-checkbox {
    width: 1.25rem;
    height: 1.25rem;
    accent-color: #f26a52;
    cursor: pointer;

    &:focus {
        outline: 2px solid rgba(242, 106, 82, 0.3);
        outline-offset: 2px;
    }
}

.settings-checkbox-label {
    font-size: clamp(0.875rem, 1.8vw, 1rem);
    font-weight: 500;
    color: rgba(55, 65, 81, 0.9);
    cursor: pointer;
    margin: 0;

    &:hover {
        color: #f26a52;
    }
}

.settings-section {
    margin-top: clamp(1.5rem, 3vw, 2rem);
    margin-bottom: clamp(1rem, 2.5vw, 1.5rem);

    &:first-child {
        margin-top: 0;
    }

    &:last-child {
        margin-bottom: 0;
    }
}

.settings-section-title {
    font-size: clamp(1rem, 2vw, 1.125rem);
    font-weight: 700;
    color: rgba(31, 41, 55, 0.9);
    margin-bottom: clamp(0.75rem, 1.8vw, 1rem);
    padding-bottom: clamp(0.375rem, 1vw, 0.5rem);
    border-bottom: 2px solid rgba(242, 106, 82, 0.2);
}

@media (max-width: 768px) {
    .captcha-settings {
        padding: 1rem;
    }
}

@media (max-width: 480px) {
    .captcha-settings {
        padding: 0.75rem;
    }

    .settings-group {
        margin-bottom: 1rem;
    }

    .settings-section {
        margin-top: 1.25rem;
        margin-bottom: 1rem;
    }
}

.captcha-settings {
    will-change: scroll-position;
}

.settings-input,
.settings-select {
    will-change: border-color, box-shadow;
}

@media (prefers-reduced-motion: reduce) {
    .settings-input,
    .settings-select {
        transition: none;
    }
}
</style>
